function getDisplayName(clip: {
  username: string;
  steamHandle: string;
}) {
  return clip.username ? clip.username : clip.steamHandle;
}

function getClipTitle(clip: {
  userClipTitle: string;
  clipTitle: string;
  clipTitleSuffix: string;
}) {
  if (!clip) return;
  if (clip.userClipTitle) {
    return `${clip.userClipTitle}`;
  }
  if (clip.clipTitle && clip.clipTitle !== "") {
    return `${clip.clipTitle}`;
  } else {
    return `${clip.clipTitleSuffix}`;
  }
}

const clipBucketURL = process.env.REACT_APP_S3_CLIP_BUCKET;

export function getSnapshotPath(snapshot: string) {
  if (!snapshot) {
    return null;
  }
  const overlayPrefix = "_w_overlay";
  let path = "/";

  if (snapshot.indexOf(overlayPrefix) !== -1) {
    path += "thumbs/" + snapshot.replace(overlayPrefix, "");
  } else {
    path += snapshot;
  }
  return clipBucketURL + path;
}

function formatNumber(num: number, lowerBoundary = 10000) {
  if (!num) {
    return 0;
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(2).toLocaleString() + "M";
  }

  if (num >= lowerBoundary) {
    return (num / 1000).toFixed(1).toLocaleString() + "K";
  }

  return num.toLocaleString();
}
